import {
  type BaseUIState,
  type PageStoreState,
  usePageStore,
} from '../../_shared/formStore'

import type { MusicGeneratorFormValuesNew } from '../_types/form'
import type { MusicPrefs } from './formStore'

type MusicFormStoreState = PageStoreState<
  MusicGeneratorFormValuesNew,
  MusicPrefs,
  BaseUIState
>

/** Music / Rap 页面通用的 formStore 消费 hook */
export function useMusicFormStore<U>(
  selector: (state: MusicFormStoreState) => U,
): U {
  return usePageStore<MusicGeneratorFormValuesNew, MusicPrefs, BaseUIState, U>(
    selector,
  )
}
